.sourcesDivider {
  margin-top: 8px;
}

.chordView {
  font-size: var(--tuna-typography-fontSize-4xl);
}

.bussesDivider {
  margin-top: 16px;
}

.sampleRate {
  display: block;
  margin-top: 16px;
}
